import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock } from 'lucide-react';
export const UrgencyBar = () => {
  // Start at 5:41 (341 seconds)
  const [timeLeft, setTimeLeft] = useState(5 * 60 + 41);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 w-full z-50 bg-prime-red border-b border-prime-redBright/30 shadow-lg" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-195">
        <motion.div animate={{
        opacity: [1, 0.5, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="flex items-center gap-2 text-white font-bold text-sm sm:text-base" data-id="element-196">
          <AlertTriangle className="w-5 h-5 text-prime-gold" data-id="element-197" />
          <span data-id="element-198">
            ¡ATENCIÓN! La oferta de lanzamiento del 90% de descuento termina en:
          </span>
        </motion.div>

        <div className="flex items-center gap-2 bg-black/30 px-3 py-1 rounded border border-white/10" data-id="element-199">
          <Clock className="w-4 h-4 text-prime-gold" data-id="element-200" />
          <span className="font-mono font-bold text-prime-gold text-lg tracking-wider" data-id="element-201">
            {formattedTime}
          </span>
        </div>

        <span className="text-white/80 text-xs sm:text-sm italic" data-id="element-202">
          (Solo para los primeros 100 pedidos hoy)
        </span>
      </div>
    </div>;
};